import api from '@whitelabel/xcover-shared/helpers/api';
import { retry } from './utils';

export const loadMessages = (locale: string, slug: string, requestInit?: RequestInit): any =>
  retry(() =>
    api.get(
      `${process.env.REACT_APP_MESSAGES_HOST}/messages/frontend/${slug}?language=${locale}`,
      false,
      requestInit || {},
    ),
  );
